import { FeatureToggleOnlineService } from './feature-toggle-online.service';

export const onlineServices = [FeatureToggleOnlineService];
